import { render, staticRenderFns } from "./Pushes.vue?vue&type=template&id=74da42b7"
import script from "./Pushes.vue?vue&type=script&lang=js"
export * from "./Pushes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports